import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../lib/auth";
import { LogOut, Sparkles, ShoppingBag } from "lucide-react";
import LanguageSwitcher from "./LanguageSwitcher";
import { BRAND } from "../lib/brand";

function Logo({ className = "h-9" }) {
  return (
    <div className="flex items-center gap-2.5">
      <img src={BRAND.logoUrl} alt="VyomSutra" className={`${className} w-auto object-contain`} />
      <div className="hidden sm:block leading-none">
        <div className="font-display text-lg font-extrabold tracking-tight text-primary">VyomSutra</div>
        <div className="text-[9px] uppercase tracking-[0.22em] text-muted-foreground mt-0.5">Essence of the Infinite</div>
      </div>
    </div>
  );
}

export default function Nav() {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onLogout = () => { logout(); navigate("/"); };

  return (
    <nav data-testid="top-nav" className="sticky top-0 z-50 w-full glass border-b border-border/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="logo-link">
          <Logo />
        </Link>

        <div className="hidden md:flex items-center gap-7">
          <Link to="/bharatiq" className="text-sm font-medium text-foreground/80 hover-underline">BharatIQ</Link>
          <Link to="/shop/wellness" className="text-sm font-medium text-foreground/80 hover-underline">Wellness</Link>
          <Link to="/shop/aura" className="text-sm font-medium text-foreground/80 hover-underline">Aura</Link>
          <Link to="/knowledge" className="text-sm font-medium text-foreground/80 hover-underline">Knowledge</Link>
        </div>

        <div className="flex items-center gap-2 sm:gap-3">
          <LanguageSwitcher />
          {user ? (
            <>
              <Link
                to="/dashboard"
                className="hidden sm:inline-flex text-sm font-medium px-3 py-2 rounded-md text-foreground/80 hover:bg-muted transition-colors"
                data-testid="nav-dashboard-link"
              >
                {t("nav.dashboard")}
              </Link>
              {user.role === "admin" && (
                <Link to="/admin" className="hidden sm:inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-2 rounded-md bg-primary/5 text-primary" data-testid="nav-admin-link">
                  <Sparkles className="w-3.5 h-3.5" /> {t("nav.admin")}
                </Link>
              )}
              <button onClick={onLogout} data-testid="nav-logout-btn" className="text-sm font-medium px-3 py-2 rounded-md text-muted-foreground hover:bg-muted transition-colors inline-flex items-center gap-1.5">
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">{t("nav.logout")}</span>
              </button>
            </>
          ) : (
            <>
              <Link to="/auth" className="text-sm font-medium px-3 sm:px-4 py-2 rounded-md text-foreground/80 hover:bg-muted transition-colors" data-testid="nav-login-link">
                {t("nav.login")}
              </Link>
              <Link to="/auth?mode=signup" className="btn-primary text-sm font-semibold px-3 sm:px-4 py-2 rounded-md" data-testid="nav-signup-btn">
                {t("nav.signup")}
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
